const saveToStorage = (key, data) => {
    sessionStorage.setItem(key, JSON.stringify(data));
  };
  
  const getFromStorage = (key) => {
    const jsonData = sessionStorage.getItem(key);
    const data = JSON.parse(jsonData);
    return data;
  };
  
  const deleteFromStorage = (key) => {
    sessionStorage.removeItem(key);
  };

  const getToken = (token) => {
    return token;
  };
  
  export { saveToStorage, getFromStorage, deleteFromStorage, getToken };
  